import CardDefault from "components/Cards/CardDefault";
import { Box, Text } from "@chakra-ui/react";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import ItemComposicao from "../ItemComposicao";
import InfiniteScroll from "react-infinite-scroll-component";
import { RelatorioComposicaoContasItem } from "core/features/relatorios/conta-com-composicoes/typings";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";
import { OperacaoEnum } from "resources/enums/conta";
import { Flex } from "@chakra-ui/layout";
import { formatMoney } from "../../../../../infra/helpers/number";

interface RelatorioComposicaoContasContentProps {
  data: RelatorioComposicaoContasItem[];
  fetchNextPage: () => any;
  hasNextPage: boolean;
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  isLoadingTotais?: boolean;
  operacao: OperacaoEnum;
  valorTotal?: number;
}

export default function RelatorioComposicaoContasContent({
  data,
  fetchNextPage,
  hasNextPage,
  isLoading,
  isFetchingNextPage,
  operacao,
  valorTotal,
}: RelatorioComposicaoContasContentProps) {
  return (
    <CardDefault
      mt={6}
      p={0}
      pt={"12px"}
      pb={data?.length && !isLoading ? 0 : "24px"}
    >
      {valorTotal ? (
        <Flex
          pl="16px"
          pr={6}
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex>
            <Text fontWeight="bold">Valor total</Text>
          </Flex>

          <Text fontWeight="bold">{formatMoney(valorTotal)}</Text>
        </Flex>
      ) : null}

      <Box mt={4}>
        {isLoading ? (
          <>
            <Skeleton w="100%" h="200px" />
          </>
        ) : null}

        {!isLoading && !data?.length ? (
          <Empty
            description={`Sem dados de ${
              operacao === OperacaoEnum.Despesa ? "despesas" : "receitas"
            } com composição para o filtro selecionado`}
          />
        ) : null}

        {!isLoading && data?.length ? (
          <>
            <InfiniteScroll
              dataLength={data?.length}
              next={() => {
                fetchNextPage();
              }}
              hasMore={!!hasNextPage}
              loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
            >
              {data?.map((item) => (
                <ItemComposicao
                  item={item}
                  key={`${item.unidade}-${item.nome}`}
                  operacao={operacao}
                />
              ))}
            </InfiniteScroll>
          </>
        ) : null}
      </Box>
    </CardDefault>
  );
}
